export const rem = (px: number | number[], base: number = 16): string => {
  const pxToRem = (px: number, base: number = 16) => `${px / base}rem`;

  if (Array.isArray(px)) {
    return px.map((p) => pxToRem(p)).join(' ');
  } else {
    return pxToRem(px);
  }
};
